/* eslint-disable jsx-a11y/anchor-is-valid */
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Estonian from './languages/Estonian';
import Russian from './languages/Russian';
import English from './languages/English';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'

console.info('v1.0.6')

function App() {
  const [csrfTokenState, setCsrfTokenState] = useState(null)
  const [availableDates, setAvailableDates] = useState([]);

  dayjs.extend(customParseFormat)
  dayjs.locale('et');

  async function getCallToForm() {
    const url = '/broneering/broneeri/api/v1/guest/form';
    return fetch(url, {
        method: 'GET',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        credentials: "include",
    })
    .then((res) => res.json())
    .then((data) => {
      if (data?.csrfToken) {
        setCsrfTokenState(data.csrfToken);
        return data.csrfToken
      }
    })
    .then((value) => value)
    .catch((err) => console.error('requesting form error ', err))
}

function getAvailableDates(token) {
  fetch('/broneering/broneeri/api/v1/guest/dates', {
    method: 'GET',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-csrf-token": token,
    },
  })
  .then((res) => res.json())
  .then((data) => {
    const filtered = data?.data?.sort((a, b) => (dayjs(a?.startDate, 'DD.MM.YYYY HH:mm').isAfter(dayjs(b?.startDate, 'DD.MM.YYYY HH:mm')) ? 1 : -1));
    setAvailableDates(filtered);
  })
  .catch((err) => console.error('Error getting dates', err))
}

useEffect(() => {
    getCallToForm().then((token) => getAvailableDates(token))
}, [])

  return (
    <Router>
      <Routes>
        <Route path='/broneering/broneeri' element={ <Navigate to="/broneering/broneeri/est" /> }></Route>
        <Route exact path='/broneering/broneeri/est' element={<Estonian getAvailableDates={getAvailableDates} getCallToForm={getCallToForm} availableDates={availableDates} csrfTokenState={csrfTokenState} />}></Route>
        <Route exact path='//broneering/broneeri/rus' element={<Russian getAvailableDates={getAvailableDates} getCallToForm={getCallToForm} availableDates={availableDates} csrfTokenState={csrfTokenState} />}></Route>
        <Route exact path='/broneering/broneeri/eng' element={<English getAvailableDates={getAvailableDates} getCallToForm={getCallToForm} availableDates={availableDates} csrfTokenState={csrfTokenState} />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
